module.exports = __webpack_public_path__ + "static/img/4-2.011102f.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/4-2.png
// module id = 269
// module chunks = 0